var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownOpacity20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.929.002L6.018 5.639 1.034.127 0 1.327l6.056 6.674L12 1.162 10.929.002z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBkPSJNMTAuOTI4NiAwLjAwMTk1MjE4TDYuMDE4MDIgNS42Mzg5OEwxLjAzMzc0IDAuMTI2OTUzTDEuMTY2NjRlLTA3IDEuMzI2OTdMNi4wNTU3MiA4LjAwMDk4TDEyIDEuMTYxOTlMMTAuOTI4NiAwLjAwMTk1MjE4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgArrowDownOpacity20 as ReactComponent };